import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const isDev = process.env.NODE_ENV === 'development';

            return (
                <div role="alert" className="error-boundary-fallback" style={{
                    padding: '2rem',
                    textAlign: 'center',
                    color: '#fff',
                    minHeight: '50vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <h2 style={{ marginBottom: '1rem', color: 'var(--primary-color, #00f0ff)' }}>
                        Something went wrong
                    </h2>
                    <p style={{ marginBottom: '1.5rem', maxWidth: '500px' }}>
                        We apologize for the inconvenience. Please try reloading the page.
                    </p>

                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-primary"
                        style={{
                            padding: '12px 24px',
                            marginBottom: '2rem'
                        }}
                    >
                        Reload Page
                    </button>

                    {isDev && (
                        <details style={{
                            whiteSpace: 'pre-wrap',
                            textAlign: 'left',
                            background: 'rgba(0,0,0,0.5)',
                            padding: '1rem',
                            borderRadius: '8px',
                            maxWidth: '100%',
                            overflow: 'auto'
                        }}>
                            <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>Error Details (Dev Only)</summary>
                            <span style={{ color: '#ff6b6b' }}>{this.state.error && this.state.error.toString()}</span>
                            <br />
                            <span style={{ opacity: 0.7, fontSize: '0.9em' }}>
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </span>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
